import Swiper, { Navigation, Pagination, A11y } from 'swiper';

export default () => {
    // awards slider
    const awardsSideSwiper = new Swiper('#awards-wrap-sidebar', {
        modules: [Navigation, Pagination, A11y],
        navigation: {
            nextEl: '#awards-wrap-sidebar .arrow-next-blue',
            prevEl: '#awards-wrap-sidebar .arrow-prev-blue',
        },
        a11y: true,
        grabCursor: true,
        loop: true,
        initialSlide: 0, // Changed from 1 to 0
        watchOverflow: true,
        slidesPerGroup: 1,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 20,
        observer: true, // Add this to watch for DOM changes
        observeParents: true, // Watch parent elements too
        on: {
            init: function() {
                this.update(); // Update on initialization
            },
            imagesReady: function() {
                this.update(); // Update when images load
            }
        }
    });
};